/**
 * HIPAA-compliant password validation.
 * Enforces complexity: min 8 chars, max 128, uppercase, lowercase, number, special char.
 */
export function validatePassword(password) {
  if (!password) return { valid: false, error: 'Password is required.' };
  if (password.length < 8) return { valid: false, error: 'Password must be at least 8 characters.' };
  if (password.length > 128) return { valid: false, error: 'Password must not exceed 128 characters.' };
  if (!/[A-Z]/.test(password)) return { valid: false, error: 'Must include at least one uppercase letter.' };
  if (!/[a-z]/.test(password)) return { valid: false, error: 'Must include at least one lowercase letter.' };
  if (!/[0-9]/.test(password)) return { valid: false, error: 'Must include at least one number.' };
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(password)) {
    return { valid: false, error: 'Must include at least one special character (!@#$%^&* etc.).' };
  }
  return { valid: true, error: '' };
}

/** Backward-compatible wrapper */
export function isValidNewPassword(password) {
  return validatePassword(password).valid;
}
